import { Navigate } from 'react-router';
import { useMe } from './useMe';
import { ErrorNotice } from '../../components/ErrorNotice';
import { LoadingScreen } from '../../components/LoadingScreen';

/**
 * `/` dispatcher (ARCHITECTURE_PLAN §10): there is no marketing landing page in
 * the app shell, so the root sends the visitor to the right real surface —
 * signed-in members to their first workspace, new users to onboarding, and
 * logged-out visitors to login.
 */
export function IndexRedirect(): React.JSX.Element {
  const me = useMe();

  if (me.isPending) {
    return <LoadingScreen />;
  }

  if (me.isError) {
    return (
      <main className="flex min-h-screen items-center justify-center px-6">
        <div className="w-full max-w-md">
          <ErrorNotice error={me.error} />
        </div>
      </main>
    );
  }

  if (me.data.user === null) {
    return <Navigate to="/login" replace />;
  }

  // §6.4: a platform admin with no memberships goes to /admin (they have no
  // implicit tenant access and do not onboard a workspace).
  if (me.data.user.isPlatformAdmin) {
    return <Navigate to="/admin" replace />;
  }

  const first = me.data.memberships[0];
  return <Navigate to={first !== undefined ? `/w/${first.slug}` : '/onboarding'} replace />;
}
